var _defs, _circle, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew285({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.09,
    cy: 7.2,
    r: 1.93
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 4.12,
    width: 6.17,
    height: 6.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9,11.83V8.51h.36v3.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.9,10.21a2,2,0,0,1,.38-1.3,1.16,1.16,0,0,1,.93-.45,1.11,1.11,0,0,1,.65.2,1.34,1.34,0,0,1,.47.59,2.36,2.36,0,0,1,.17.92,2,2,0,0,1-.33,1.2,1.15,1.15,0,0,1-1,.51,1.11,1.11,0,0,1-1-.52A1.91,1.91,0,0,1,9.9,10.21Zm.38,0a1.49,1.49,0,0,0,.26.95.81.81,0,0,0,.66.34.82.82,0,0,0,.66-.34,1.62,1.62,0,0,0,.27-1A1.84,1.84,0,0,0,12,9.4.87.87,0,0,0,11.67,9a.72.72,0,0,0-.46-.16.8.8,0,0,0-.67.34A1.69,1.69,0,0,0,10.28,10.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.84,10.76l.34,0a.81.81,0,0,0,.12.43.73.73,0,0,0,.27.25.91.91,0,0,0,.41.09.67.67,0,0,0,.49-.16.55.55,0,0,0,.12-.66.59.59,0,0,0-.2-.18,3.33,3.33,0,0,0-.56-.2,2,2,0,0,1-.55-.23A.79.79,0,0,1,13,9.77a.87.87,0,0,1-.09-.4.9.9,0,0,1,.26-.66,1,1,0,0,1,.7-.25,1.12,1.12,0,0,1,.53.12.82.82,0,0,1,.35.34,1.09,1.09,0,0,1,.14.52l-.35,0A.71.71,0,0,0,14.38,9a.64.64,0,0,0-.47-.16.68.68,0,0,0-.46.14.43.43,0,0,0-.16.35.38.38,0,0,0,.11.31,1.41,1.41,0,0,0,.53.23,3.66,3.66,0,0,1,.57.19,1,1,0,0,1,.37.33.91.91,0,0,1,.13.5,1.14,1.14,0,0,1-.13.52.89.89,0,0,1-.37.35,1.15,1.15,0,0,1-.55.12,1.07,1.07,0,0,1-.8-.3A1.11,1.11,0,0,1,12.84,10.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew285);
export default __webpack_public_path__ + "static/media/Symbolpack_New_285.8f0ce47528be14559789b56aa91188e1.svg";
export { ForwardRef as ReactComponent };